module.exports = __webpack_public_path__ + "img/paiement-securise-par-stripe-300x145.26415d32.png";